<div class="products-container">
  <!-- Products header bar -->
  <div class="products-container-header" *ngIf="options.triggerPage === 'catalog-edit'">
    <div class="header-title">
      {{ options.title ? (options.title | translate) : "" }}
    </div>
    <div class="header-stats">
      <div class="header-stats-item">
        <span class="number">{{ getTotalSelectedCount() }}</span>
        {{ 'Catalogs.new_catalog.products.select_all.selected_of' | translate: { count: productsMetadata?.count || 0 } }}
      </div>
      <div class="header-stats-item" *ngIf="!areAllValidProductsSelected()">
        <span (click)="selectAllProducts()" class="number" [class.loading]="isSelectingAll" [style.pointer-events]="(!canSubmit || isSelectingAll) ? 'none' : 'auto'">
          <span *ngIf="!isSelectingAll">{{ 'Catalogs.new_catalog.products.select_all.select_all_button' | translate }}</span>
          <span *ngIf="isSelectingAll">{{ 'Catalogs.new_catalog.products.select_all.loading' | translate }}</span>
        </span>
      </div>
      <div class="header-stats-item" *ngIf="areAllValidProductsSelected()">
        <span (click)="cancelSelectAll()" class="number" [style.pointer-events]="!canSubmit ? 'none' : 'auto'">{{ 'Catalogs.new_catalog.products.select_all.deselect_all' | translate }}</span>
      </div>
    </div>
  </div>

  <app-gift-banner *ngIf="featureFlags.loyaltyEnabled && catalog && getGifts().length > 0" [gifts]="getGifts()"></app-gift-banner>

  <!-- Filter bar -->
  <div class="filters" *ngIf="options.triggerPage === 'catalog-edit'">
    <div class="search-filter-group">
      <!-- Search Box -->
      <div class="search-box" [style.width]="!searchInput.value ? 'auto' : null">
        <div class="search-field">
          <input
            type="text"
            data-testid="catalog-products-search"
            placeholder="{{ 'Catalogs.new_catalog.products.listing.search' | translate }}"
            [formControl]="searchInput"
            (input)="search($event)"
            [style.width]="!searchInput.value ? 'auto' : null"
            [attr.size]="!searchInput.value ? ('Catalogs.new_catalog.products.listing.search' | translate).length : null"
          />
          <div class="search-icon">
            <img src="assets/icones/search_icon.svg" alt="" />
          </div>
        </div>
      </div>
      <!-- Filter Button -->
      <div class="filter-button-group">
        <button class="action-button" [class.activeFilter]="options.filterIsActive" (click)="openFilter.emit()">
          <div class="action-button-icon">
            <img src="assets/icones/filter_icon.svg" alt="" />
          </div>
          <span class="action-button-text">{{ "common.filter" | translate }}</span>
          <div class="clear-icon-container">
            <img
              class="clear-icon"
              *ngIf="options.filterIsActive"
              (click)="clearFilter.emit(); $event.stopPropagation()"
              src="assets/icones/clear-icon.svg"
              alt=""
            />
            <div class="clear-tooltip" *ngIf="options.filterIsActive">
              {{ "common.clear_filters" | translate }}
            </div>
          </div>
        </button>
      </div>

      <div class="validator-container" *ngIf="source === 'catalogs'">
        <div [matTooltip]="getValidationTooltipMessage()" class="info_Validator" *ngIf="areSelectedProductsValid() === false">
          <img src="assets/icones/alert-circle-red.svg" alt="" />
          <span>{{ getGlobalValidationMessage() }}</span>
        </div>

        <div class="currencies-select-container">
          <div class="standard-input standard-input-currency">
            <mat-select [formControl]="currencyControl">
              <mat-option *ngFor="let currency of availableCurrencies" [value]="currency.id">{{ currency.name }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>

      <div [matTooltip]="getValidationTooltipMessage()" class="info_Validator" *ngIf="source === 'agents' && areSelectedProductsValid() === false" style="margin-left: auto;">
        <img src="assets/icones/alert-circle-red.svg" alt="" />
        <span>{{ getGlobalValidationMessage() }}</span>
      </div>
    </div>
  </div>

  <!-- No products message -->
  <div class="empty-products-message" *ngIf="filteredProducts.length === 0">
    <div class="message-content">
      <p>{{ "Catalogs.new_catalog.products.listing.no_products_found" | translate }}</p>
    </div>
  </div>

  <!-- Products table -->
  <div class="products-content" *ngIf="filteredProducts.length > 0">
    <form [formGroup]="productsForm">
      <table class="products-table" *ngIf="options.triggerPage === 'catalog-edit' || options.triggerPage === 'catalog-view'">
        <thead>
          <tr
            class="row header"
            [class.catalog-edit-row]="hasExtraDiscount && options.triggerPage === 'catalog-edit'"
            [class.catalog-edit-row-no-extra-discount]="!hasExtraDiscount && options.triggerPage === 'catalog-edit'"
            [class.catalog-view-row]="options.triggerPage === 'catalog-view'"
            [class.quantity-rules-row]="(source === 'catalogs' || source === 'agents') && options.triggerPage === 'catalog-edit'"
            [class.has-cost-column]="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'"
            [class.hide-full-pricing]="!showFullPricingData"
            style="padding-top: 10px; border: unset; height: unset"
          >
            <!-- Image -->
            <th>
              <!-- Fake checkbox: only shows when "select all" is active -->
              <mat-checkbox 
                *ngIf="hasSelectedAllProducts"
                [checked]="true" 
                [indeterminate]="false" 
                [disabled]="!canSubmit"
                (change)="cancelSelectAll()">
              </mat-checkbox>
              <!-- Original checkbox: shows when "select all" is NOT active -->
              <mat-checkbox 
                *ngIf="!hasSelectedAllProducts"
                [checked]="isAllProductsSelected()" 
                [indeterminate]="isPartialSelectedAll()" 
                [disabled]="!canSubmit"
                (change)="toggleAllProducts($event.checked)">
              </mat-checkbox>
              {{ "Catalogs.new_catalog.products.listing.img" | translate }}
            </th>
            <!-- Product Name -->
            <th class="sortable-column">
              {{ "quotations_and_orders.product" | translate }}
              <div class="sort-actions">
                <span class="arrow-up" [class.active]="activeSortKey === 'name' && activeSortMode == 'asc'" (click)="sortByKey('name', 'asc')"></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'name' && activeSortMode == 'desc'"
                  (click)="sortByKey('name', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Brand -->
            <th class="sortable-column">
              {{ "Catalogs.new_catalog.products.listing.brand" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'brand' && activeSortMode == 'asc'"
                  (click)="sortByKey('brand', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'brand' && activeSortMode == 'desc'"
                  (click)="sortByKey('brand', 'desc')"
                ></span>
              </div>
            </th>
            <!-- MSRP -->
            <th class="sortable-column" *ngIf="showFullPricingData">
              {{ "Catalogs.new_catalog.products.listing.msrp" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'sales_price' && activeSortMode == 'asc'"
                  (click)="sortByKey('sales_price', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'sales_price' && activeSortMode == 'desc'"
                  (click)="sortByKey('sales_price', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Cost -->
            <th class="sortable-column" *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
              {{ "Catalogs.new_catalog.products.listing.cost" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'cost' && activeSortMode == 'asc'"
                  (click)="sortByKey('cost', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'cost' && activeSortMode == 'desc'"
                  (click)="sortByKey('cost', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Margin -->
            <th class="sortable-column" *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
              {{ "Catalogs.new_catalog.products.listing.margin" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'discount' && activeSortMode == 'asc'"
                  (click)="sortByKey('discount', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'discount' && activeSortMode == 'desc'"
                  (click)="sortByKey('discount', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Discount -->
            <th class="sortable-column" *ngIf="showFullPricingData && options.triggerPage === 'catalog-edit' && newCatalogPricingRules.pricing_rule !== 'margin'">
              {{ "Catalogs.new_catalog.products.listing.discount" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'discount' && activeSortMode == 'asc'"
                  (click)="sortByKey('discount', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'discount' && activeSortMode == 'desc'"
                  (click)="sortByKey('discount', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Final Price -->
            <th class="sortable-column">
              {{ "Catalogs.new_catalog.products.listing.final_price" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'final_price' && activeSortMode == 'asc'"
                  (click)="sortByKey('final_price', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'final_price' && activeSortMode == 'desc'"
                  (click)="sortByKey('final_price', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Extra Discount -->
            <th class="sortable-column" *ngIf="showFullPricingData && options.triggerPage === 'catalog-edit' && hasExtraDiscount">
              {{ "Catalogs.new_catalog.products.listing.extra_discount" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'extra_discount' && activeSortMode == 'asc'"
                  (click)="sortByKey('extra_discount', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'extra_discount' && activeSortMode == 'desc'"
                  (click)="sortByKey('extra_discount', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Stock -->
            <th class="sortable-column">
              {{ "Catalogs.new_catalog.products.listing.stock" | translate }}
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="activeSortKey === 'stock' && activeSortMode == 'asc'"
                  (click)="sortByKey('stock', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="activeSortKey === 'stock' && activeSortMode == 'desc'"
                  (click)="sortByKey('stock', 'desc')"
                ></span>
              </div>
            </th>
            <th *ngIf="(source === 'catalogs' || source === 'agents') && options.triggerPage === 'catalog-edit'">
              {{ "Catalogs.quantity_preference" | translate }}
            </th>
          </tr>
         <tr
            class="row header"
            [class.catalog-edit-row]="hasExtraDiscount && options.triggerPage === 'catalog-edit'"
            [class.catalog-edit-row-no-extra-discount]="!hasExtraDiscount && options.triggerPage === 'catalog-edit'"
            [class.catalog-view-row]="options.triggerPage === 'catalog-view'"
            [class.quantity-rules-row]="(source === 'catalogs' || source === 'agents') && options.triggerPage === 'catalog-edit'"
            [class.has-cost-column]="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'"
            [class.hide-full-pricing]="!showFullPricingData"
            style="padding-bottom: 10px; height: unset"
          >
            <!-- Img -->
            <th></th>
            <!-- Product Name -->
            <th class="sortable-column">
              <span style="font-weight: 400" class="secondary-text">
                {{ "Catalogs.new_catalog.products.listing.sku" | translate }}
              </span>
              <div class="sort-actions">
                <span
                  class="arrow-up"
                  [class.active]="
                    activeSortKey === 'sku' && activeSortMode == 'asc'
                  "
                  (click)="sortByKey('sku', 'asc')"
                ></span>
                <span
                  class="arrow-down"
                  [class.active]="
                    activeSortKey === 'sku' && activeSortMode == 'desc'
                  "
                  (click)="sortByKey('sku', 'desc')"
                ></span>
              </div>
            </th>
            <!-- Brand -->
            <th></th>
            <!-- MSRP -->
            <th *ngIf="showFullPricingData">
              <span style="font-weight: 400" class="secondary-text"> ({{ "Catalogs.new_catalog.products.listing.retail_price" | translate }}) </span>
            </th>
            <!-- Cost -->
            <th *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
              <span style="font-weight: 400" class="secondary-text"></span>
            </th>
            <!-- Margin -->
            <th *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
              <span style="font-weight: 400" class="secondary-text">
                ({{ "Catalogs.new_catalog.products.listing.on_cost" | translate }})
              </span>
            </th>
            <!-- Discount -->
            <th *ngIf="options.triggerPage === 'catalog-edit' && newCatalogPricingRules.pricing_rule !== 'margin'">
              <span style="font-weight: 400" class="secondary-text">
                ({{ "Catalogs.new_catalog.products.listing.on_retail_price" | translate }})
              </span>
            </th>
            <!-- Final Price -->
            <th>
              <span style="font-weight: 400" class="secondary-text" *ngIf="options.triggerPage === 'catalog-view' && hasExtraDiscount">
                {{ "Catalogs.new_catalog.products.listing.max_extra_discount" | translate }}
              </span>
            </th>
            <!-- Extra Discount -->
            <th *ngIf="showFullPricingData && options.triggerPage === 'catalog-edit' && hasExtraDiscount">
              <span style="font-weight: 400" class="secondary-text">
                {{ "Catalogs.new_catalog.products.listing.maximum" | translate }}
              </span>
            </th>
            <!-- Stock -->
            <th></th>
          </tr>
        </thead>
        <tbody>
          <div class="products-viewport" (scroll)="onScroll($event)" #scrollContainer>
            <ng-container *ngFor="let product of filteredProducts; trackBy: trackByProductId">
              <tr
                class="row"
                [attr.data-testid]="'catalog-product-row-' + product.id"
                [class.catalog-edit-row]="hasExtraDiscount && options.triggerPage === 'catalog-edit'"
                [class.catalog-edit-row-no-extra-discount]="!hasExtraDiscount && options.triggerPage === 'catalog-edit'"
                [class.catalog-view-row]="options.triggerPage === 'catalog-view'"
                [class.quantity-rules-row]="(source === 'catalogs' || source === 'agents') && options.triggerPage === 'catalog-edit'"
                [class.has-cost-column]="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'"
                [class.hide-full-pricing]="!showFullPricingData"
                [class.draft-product]="(product.status === 'Draft' || !product.enabled)"
                [matTooltip]="(product.status === 'Draft') ? ('Catalogs.new_catalog.products.listing.draft_product' | translate) : (!product.enabled) ? ('Catalogs.new_catalog.products.listing.disabled_product' | translate) : ''"
                matTooltipPosition="after"
                matTooltipClass="draft-tooltip"
              >
                <!-- Image -->
                <td >
                  <mat-checkbox
                    [attr.data-testid]="'catalog-product-checkbox-' + product.id"
                    [checked]="isProductSelected(product)"
                    [disabled]="!canSubmit || !isProductValid(product)"
                    (change)="toggleProduct(product, $event.checked)"
                    (click)="$event.stopPropagation()"
                  ></mat-checkbox>
                  <img
                    class="thumbmail-image"
                    [class]="!product.image ? 'no-image' : ''"
                    [src]="failedImages.has(product.image!) ? 'assets/icones/default-image-product.svg' : getImage(product.image!)"
                    alt=""
                    (error)="onImageError(product.image!)"
                  />
                </td>
                <!-- Product Name -->
                <td (click)="showDetails(product)">
                  <span class="truncate" [title]="product.name">
                    {{ product.name }}
                  </span>
                  <span class="secondary-text">{{ product.sku }}</span>
                </td>
                <!-- Brand -->
                <td>
                  <span class="truncate" [title]="product.brand?.name || ''">
                    {{ product.brand?.name || "--" }}
                  </span>
                </td>
                <!-- MSRP -->
                <td *ngIf="showFullPricingData">
                  <div class="price-info">
                    <span>
                      {{
                        getCurrencyPrice(product, "sales_price")
                          ? getCurrencyPrice(product, "sales_price")!.toLocaleString(undefined, {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            }) + getCurrencySymbol()
                          : "--"
                      }}
                    </span>
                    <app-gift-tooltip *ngIf="featureFlags.loyaltyEnabled && showFullPricingData && getProductGifts(product).length > 0 && product.status !== 'Draft'" [gifts]="getProductGifts(product)"></app-gift-tooltip>
                  </div>
                </td>
                <!-- Cost -->
                <td *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
                  <span>
                    {{
                      getCurrencyCost(product)
                        ? getCurrencyCost(product)!.toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                          }) + getCurrencySymbol()
                        : "--"
                    }}
                  </span>
                </td>
                <!-- Margin (using discount field) -->
                <td *ngIf="showFullPricingData && newCatalogPricingRules.pricing_rule === 'margin'">
                  <div *ngIf="options.triggerPage === 'catalog-edit'; else viewMargin">
                    <div *ngIf="getCurrencyCost(product) && getCurrencyCost(product)! > 0; else noCost" class="standard-input has-icon">
                      <div class="input-container">
                        <input
                          type="number"
                          name="discount"
                          [formControl]="getFormControl('discount_' + getProductFormId(product))"
                          [readonly]="!canSubmit"
                          [class.error]="hasFieldError('discount_' + getProductFormId(product))"
                          (input)="
                            onInputRemoveLeadingZero($event, productsForm, 'discount_' + getProductFormId(product));
                            onInputCheckValidity('discount', product);
                            onDiscountChange($event, product)
                          "
                          (click)="$event.stopPropagation()"
                        />
                        <span class="btn-icon" style="cursor: default">%</span>
                      </div>
                      <mat-icon 
                        class="error-icon" 
                        *ngIf="hasFieldError('discount_' + getProductFormId(product))"
                        [matTooltip]="getFieldError('discount_' + getProductFormId(product))"
                        matTooltipPosition="above"
                        matTooltipClass="error-tooltip"
                      >
                        warning
                      </mat-icon>
                    </div>
                    <ng-template #noCost>
                      <span> -- </span>
                    </ng-template>
                  </div>
                  <ng-template #viewMargin>
                    <span>{{ getMarginDisplay(product) }}</span>
                  </ng-template>
                </td>
                <!-- Discount -->
                <td *ngIf="options.triggerPage === 'catalog-edit' && newCatalogPricingRules.pricing_rule !== 'margin'">
                  <div *ngIf="getCurrencyPrice(product, 'sales_price'); else noSalesPrice" class="standard-input has-icon">
                    <div class="input-container">
                      <input
                        type="number"
                        name="discount"
                        [formControl]="getFormControl('discount_' + getProductFormId(product))"
                        [readonly]="!canSubmit"
                        [class.error]="hasFieldError('discount_' + getProductFormId(product))"
                        min="0"
                        max="100"
                        (input)="
                          onInputRemoveLeadingZero($event, productsForm, 'discount_' + getProductFormId(product));
                          onInputCheckValidity('discount', product);
                          onDiscountChange($event, product)
                        "
                        (click)="$event.stopPropagation()"
                      />
                      <span class="btn-icon" style="cursor: default">%</span>
                    </div>
                     <mat-icon 
                       class="error-icon" 
                       *ngIf="hasFieldError('discount_' + getProductFormId(product))"
                       [matTooltip]="getFieldError('discount_' + getProductFormId(product))"
                       matTooltipPosition="above"
                       matTooltipClass="error-tooltip"
                     >
                       warning
                     </mat-icon>
                  </div>
                  <ng-template #noSalesPrice>
                    <span> -- </span>
                  </ng-template>
                </td>
                <!-- Final Price -->
                <td>
                  <div class="price-info" style="display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                    <div *ngIf="options.triggerPage === 'catalog-edit'; else viewFinalPrice" class="standard-input has-icon">
                      <div class="input-container">
                        <input
                          type="number"
                          name="final_price"
                        [readonly]="!canSubmit"
                        [formControl]="
                          getFormControl('final_price_' + getProductFormId(product))
                        "
                        [class.error]="hasFieldError('final_price_' + getProductFormId(product))"
                        min="0"
                        (input)="
                          onInputRemoveLeadingZero($event, productsForm, 'final_price_' + getProductFormId(product));
                          onInputCheckValidity('final_price', product);
                          onFinalPriceChange($event, product)
                        "
                        (click)="$event.stopPropagation()"
                      />
                      <span class="btn-icon" style="cursor: default"> {{getCurrencySymbol()}} </span>
                      <mat-icon 
                        class="error-icon" 
                        *ngIf="hasFieldError('final_price_' + getProductFormId(product))"
                        [matTooltip]="getFieldError('final_price_' + getProductFormId(product))"
                          matTooltipPosition="above"
                          matTooltipClass="error-tooltip"
                        >
                          warning
                        </mat-icon>
                      </div>
                    </div>
                    <ng-template #viewFinalPrice>
                      <div style="display: flex; flex-direction: column">
                        <span>
                          {{
                            getCurrencyPrice(product, "final_price")
                              ? getCurrencyPrice(product, "final_price")!.toLocaleString(undefined, {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2
                                }) + getCurrencySymbol()
                              : "--"
                          }}
                        </span>
                        <span
                          style="font-weight: 400"
                          class="secondary-text"
                          *ngIf="hasExtraDiscount"
                        >
                          {{ (product.extra_discount || product.max_extra_discount) + "%" }}
                        </span>
                      </div>
                    </ng-template>
                    <app-gift-tooltip *ngIf="featureFlags.loyaltyEnabled && !showFullPricingData && getProductGifts(product).length > 0 && product.status !== 'Draft'" [gifts]="getProductGifts(product)"></app-gift-tooltip>
                  </div>
                </td>
                <!-- Extra Discount -->
                <td *ngIf="showFullPricingData && options.triggerPage === 'catalog-edit' && hasExtraDiscount">
                  <div class="standard-input has-icon">
                    <div class="input-container">
                      <input
                        type="number"
                        name="extra_discount"
                        [readonly]="!canSubmit"
                        [formControl]="
                          getFormControl('extra_discount_' + getProductFormId(product))
                        "
                        [class.error]="hasFieldError('extra_discount_' + getProductFormId(product))"
                        min="0"
                        max="100"
                        (input)="
                          onInputRemoveLeadingZero($event, productsForm, 'extra_discount_' + getProductFormId(product));
                          onInputCheckValidity('extra_discount', product);
                          emitSelectedProducts()
                        "
                        (click)="$event.stopPropagation()"
                      />
                      <span class="btn-icon" style="cursor: default">%</span>
                      <mat-icon 
                        class="error-icon" 
                        *ngIf="hasFieldError('extra_discount_' + getProductFormId(product))"
                        [matTooltip]="getFieldError('extra_discount_' + getProductFormId(product))"
                        matTooltipPosition="above"
                        matTooltipClass="error-tooltip"
                      >
                        warning
                      </mat-icon>
                    </div>
                  </div>
                </td>
                <!-- Stock -->
                <td>
                  <ng-container *ngIf="product?.is_owned === false; else owned">
                    <span class="tag neutral">
                      {{ "inventory.notOwned" | translate }}
                    </span>
                  </ng-container>
                  <ng-template #owned>
                    <div>
                      {{ product.stock?.quantity }}
                    </div>
                  </ng-template>
                </td>
                <td class="last_td" *ngIf="(source === 'catalogs' || source === 'agents') && options.triggerPage === 'catalog-edit'">
                  <div class="info_hint">
                    <img src="assets/icones/info.svg" alt="" />
                    <span>{{ "quotations_and_orders.overall_quantity" | translate }}</span>
                  </div>
                  <div class="cover_div">
                    <div class="info_hint">
                      <img src="assets/icones/info.svg" alt="" />
                      <span>{{ "quotations_and_orders.overall_quantity" | translate }}</span>
                    </div>
                    <div class="spans">
                      <span>{{ "Catalogs.min" | translate }} : {{ product.min_qte }}</span>
                      <span>{{ "Catalogs.max" | translate }} : {{ product.max_qte }}</span>
                      <span>{{ "Catalogs.increment" | translate }}: {{ product.increment }}</span>
                      <span
                        >{{ "Catalogs.can_be_sold_out_of_stock_short" | translate }}:
                        {{ (product.can_be_sold_out_of_stock ? "common.yes" : "common.no") | translate }}</span
                      >
                    </div>
                    <div class="info_hint override" *ngIf="canSubmit" (click)="openOverride(product)">
                      <img src="../../../../../assets/icones/add.svg" alt="" />
                      <span>{{ "Catalogs.overrides" | translate }}</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                class="alert-banner"
                *ngIf="
                  newCatalogPricingRules.pricing_rule !== 'margin' &&
                  getCurrencyPrice(product, 'sales_price') &&
                  productsForm.get('final_price_' + getProductFormId(product))?.value > getCurrencyPrice(product, 'sales_price')!
                "
              >
                <img src="../../../../../assets/icones/alert-circle.svg" alt="" />
                <span>{{ "Catalogs.new_catalog.products.listing.final_price_superior" | translate }}</span>
              </tr>
              <!-- Alert for missing final prices in multi-currency mode -->
              <tr 
                class="alert-banner" 
                *ngIf="isMultiCurrency && hasMissingFinalPriceForAnyCurrency(product)"
              >
                <img src="../../../../../assets/icones/alert-circle.svg" alt="" />
                <span>{{ getMissingFinalPriceCurrenciesMessage(product) }}</span>
              </tr>
              <!-- Alert for zero final price (only if not in multi-currency mode with missing currencies) -->
              <tr 
                class="alert-banner" 
                *ngIf="
                  (productsForm.get('final_price_' + getProductFormId(product))?.value === 0) &&
                  (!isMultiCurrency || getMissingFinalPriceCurrencies(product).length === 0)
                "
              >
                <img src="../../../../../assets/icones/alert-circle.svg" alt="" />
                <span>{{ getZeroFinalPriceMessage(product) }}</span>
              </tr>
              <!-- <ng-container *ngIf="catalog && catalog.deals!.length > 0 && product.deals!.length > 0">
                <tr class="alert-banner reward-message" *ngIf="getProductSpecificDiscountIfAvailable(product, catalog!)">
                  <img src="../../../../../assets/icones/reward.svg" alt="" />
                  <span [innerHTML]="getProductSpecificDiscountRewardMessage(product, catalog!)?.message"></span>
                </tr>
              </ng-container> -->
            </ng-container>
            <!-- <tr *ngIf="hasMore" (click)="loadMore.emit()" class="show-more">
              Show More ({{products.length +  '/' + productsMetadata?.count }})
            </tr> -->
            <div *ngIf="isLoadingMore" class="loading-more-container">
              <app-loader></app-loader>
            </div>
          </div>
        </tbody>
      </table>
    </form>
  </div>
</div>
